import base from './base';
import zabota from './zabota';
import ecp from './ecp';
import uslugirt from './uslugirt';
export default {
    base: base,
    zabota: zabota,
    ecp: ecp,
    uslugirt: uslugirt,
};
//# sourceMappingURL=index.js.map